<template>
    <div class="page">
        <div class="page-content1">
            <div class="left">
                <el-tree style="display: block;font-size: 14px;" :expand-on-click-node="false" default-expand-all current-node-key="0" node-key="id" highlight-current :data="cmsAdsCategoryList"
                    :props="{ children: 'children', label: 'categoryName' }" size="small">
                    <div class="custom-tree-node flex items-center" style="flex: 1;" slot-scope="{ node, data }">
                        <div style="display: flex;justify-content: space-between;flex:1;align-items: center;">
                            <div style="display: flex;align-items: center;flex: 1;" @click="handleNodeClick(data)">
<!--                                <i class="el-icon-s-data"></i>-->
                                <span class="ml-1">{{ node.label }}</span>
                            </div>
                        <!-- <el-dropdown @command="handleCommand">
                            <span class="el-dropdown-link">
                            <i class="el-icon-more"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="'add',data" v-if="data.folderName != '全部文件'">新增分类</el-dropdown-item>
                            <el-dropdown-item :command="'',data" v-else="data.folderName != '全部文件'">新增分类</el-dropdown-item>
                            <el-dropdown-item :command="'edit',data" v-if="data.folderName != '全部文件'">编辑分类</el-dropdown-item>
                            <el-dropdown-item :command="'delete',data" v-if="data.folderName != '全部文件'">删除分类</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown> -->
                        </div>
                    </div>
                </el-tree>
            </div>
            <div class="right">
                <div class="top">
                    <el-carousel height="320px" v-if="cmsAdsList.length > 0">
                        <el-carousel-item style="display: flex;align-items: center;justify-content: center;" v-for="item in cmsAdsList" :key="item.id">
                            <h3 class="small" style="display: flex;align-items: center;justify-content: center;"><img :src="item.adsPic" alt="这是一张图片"></h3>    
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="button">
                    <el-table
                    :data="cmsAdsList"
                    row-key="id"
                    border
                    height="100%"
                    :header-row-style="{height: '10px'}"
                    :header-cell-style="{padding: '10px'}"
                    :row-style="{height: '9px'}"
                    :cell-style="{padding: '9px'}"
                    
                    size="small"
                    >
                    <!-- <el-table-column
                        align="center"
                        type="selection"
                        width="60"
                    > </el-table-column> -->
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="adsName"
                        label="广告名称"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="adsPic"
                        label="广告图片"
                        width="180"
                    > 
                        <template slot-scope="scope">
                            <div v-if='scope.row.adsPic'>
                            <el-image @click='updateSrcList(scope.row.adsPic)' style="width: 60px; height: 60px"
                                :src="scope.row.adsPic" :preview-src-list="srcList"> </el-image>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="linkType"
                        label="链接类型"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{ getadslinks(scope.row.linkType) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="adsLink"
                        label="广告链接"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="categoryId"
                        label="分类"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{ getcmsCategorys(scope.row.categoryId) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="isShow"
                        label="是否显示"
                        width="180"
                    >
                        <template slot-scope="scope">
                        {{ adsyesno(scope.row.isShow) }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="sort"
                        label="排序"
                        width="180"
                    > </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        align="center"
                        prop="createTime"
                        label="创建时间"
                        width="180"
                    > </el-table-column>
                        <el-table-column
                            fixed="right"
                            align="center"
                            label="操作"
                            width="160"
                        >
                            <template slot-scope="scop">
                            <div class="operation">
                                <!-- <div @click="checkCmsAds(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                                </div> -->
                                <div @click="editCmsAds(scop.row.id)">
                                    <Icon size="16">
                                        <Edit24Regular />
                                    </Icon>
                                    <span class="operation-label">修改</span>
                                </div>
                                <div @click="deleteCmsAds(scop.row.id)">
                                    <Icon size="16" style="color: red">
                                        <Delete24Regular />
                                    </Icon>
                                    <span class="operation-label" style="color: red">删除</span>
                                </div>
                            </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
            :title="'修改信息'"
            :visible.sync="showDialog"
            width="60%"
            @close="closeDialog"
            >
            <div>
                <el-form
                :model="cmsAds"
                ref="cmsAdsForm"
                :rules="rules"
                label-width="120px"
                :inline="true"
                size="small"
                >
                <el-form-item
                    label="广告名称"
                    prop="adsName"
                >
                    <el-input
                    size="small"
                    style="width: 200px"
                    v-model="cmsAds.adsName"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="广告图片"
                    prop="adsPic"
                >
<!--                    <el-input-->
<!--                    size="small"-->
<!--                    style="width: 200px"-->
<!--                    v-model="cmsAds.adsPic"-->
<!--                    ></el-input>-->
                    <div style="display: flex;width: 200px;">
                        <el-input v-model="cmsAds.adsPic" size="small"></el-input>
                        <el-button type="primary" size="small" style="margin-left: 2px;" @click="uploadImages">上传图片
                            <!-- <el-upload :action="action" :headers="header" v-show="false" :before-upload="beforeImageUpload" ref="uploads" class="avatar-uploader" :show-file-list="false"
                            :http-request="uploadImage">
                            <el-button type="primary" size="small" class="as">上传</el-button>
                        </el-upload> -->
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item
                    label="链接类型"
                    prop="linkType"
                >
                    <!-- <el-input
                    size="small"
                    style="width: 200px"
                    v-model="cmsAds.linkType"
                    
                    ></el-input> -->
                    <el-select placeholder="请选择状态"  clearable style="width: 200px"
                        size="small" v-model="cmsAds.linkType">
                        <el-option v-for='(item, index) in adsLinkList' :key='index' :label="item.value" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="广告链接"
                    prop="adsLink"
                >
<!--                    <el-input-->
<!--                    size="small"-->
<!--                    style="width: 200px"-->
<!--                    v-model="cmsAds.adsLink"-->
<!--                    ></el-input>-->
                    <pathselect
                        style="width: 200px"
                        :value="cmsAds.adsLink"
                        @change="changePathSelect"
                    ></pathselect>
                </el-form-item>
                <el-form-item
                    label="分类"
                    prop="categoryId"
                >
                <el-select
                    style="width: 200px"
                    v-model="cmsAds.categoryId"
                    placeholder="请选择分类名称"
                    clearable
                    size="small"
                >
                    <el-tree default-expand-all :data="mppFileFolderList" :props="{ children: 'children', label: 'folderName' }">
                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                            <el-option :label="data.categoryName" :value="data.id"> </el-option>
                        </div>
                    </el-tree>
                </el-select>
                </el-form-item>
                <el-form-item
                    label="是否显示"
                    prop="isShow"
                >
                    <!-- <el-input
                    size="small"
                    v-model="cmsAds.isShow"
                    ></el-input> -->
                    <el-select placeholder="请选择状态"  clearable style="width: 200px"
                        size="small" v-model="cmsAds.isShow">
                        <el-option v-for='(item, index) in yesNoList' :key='index' :label="item.value" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="排序"
                    prop="sort"
                >
                    <el-input
                    size="small"
                    style="width: 200px"
                    v-model="cmsAds.sort"
                    ></el-input>
                </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                type="primary"
                @click="submitForm"
                >确定</el-button>
            </div>
            </el-dialog>
        </div>
        <!-- 上传调用部分 -->
        <el-upload :action="action" :headers="header" v-show="false" :before-upload="beforeImageUpload" ref="uploads" class="avatar-uploader" :show-file-list="false"
                   :http-request="uploadImage">
            <el-button type="primary" size="small" class="as">上传</el-button>
        </el-upload>
    </div>
</template>
<script>
import { get, deleteFun, post, upload } from '@/utils/request';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';
import Pathselect from '@/components/pathselect/pathselect.vue';
export default {
    components: {
        Pathselect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
    },
    data(){
        return{
            cmsAdsCategoryList:[],
            cmsAdsList:[],
            mppFileFolderList:[],
            getEumnList:[],
            adsLinkList:[],
            yesNoList:[],
            srcList:[''],
            currentCmsAdsId:'',
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            cmsAds: {
                adsName: '', //广告名称
                adsPic: '', //广告图片
                linkType: '', //链接类型
                adsLink: '', //广告链接
                categoryId: '', //分类ID
                isShow: '', //是否显示
                sort: '', //排序
                createTime: '', //
            },
            ccId:'',
            showDialog:false,
            rules: {
                adsName: [{ required: true, message: '广告名称不能为空', trigger: 'blur' }],
                adsPic: [{ required: true, message: '广告图片不能为空', trigger: 'blur' }],
                linkType: [{ required: true, message: '链接类型不能为空', trigger: 'blur' }],
                adsLink: [{ required: true, message: '广告链接不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '分类ID不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
            },
        }
    },
    created(){
        this.getCmsAdsCategoryList()
        // this.getCmsAdsList();
        this.getCmsAdsLists();
        this.getEumnLists();
        this.getMppFileFolderList()
    },
    methods:{
        changePathSelect(path) {
            this.cmsAds.adsLink = path;
        },
        uploadImages() {
            this.$refs.uploads.$el.querySelector(".as").click()
        },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        //上传缩略图
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.$message.success(res.msg)
                    this.cmsAds.adsPic = res.url
                }else{
                    this.$message.error(res.msg)
                }
            });
        },
        getCmsAdsCategoryList(query = {}) {
            get(`/cms/adscategory/findAllAsTree`).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.cmsAdsCategoryList = res.treeData;
                    // this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMppFileFolderList() {
            get(`cms/adscategory/findAllAsTree`).then((res) => {
            this.loading = false;
            if (res.success) {
                this.mppFileFolderList = res.treeData;
                console.log(this.mppFileFolderList);
                // this.totalNum = res.page.total;
            } else {
                this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
                });
            }
            });
        },
        // 分类
        getEumnLists(){
            get(`/cms/adscategory/findAll`).then((res) => {
                if (res.success) {
                    console.log(res)
                    this.getEumnList = res.list;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getcmsCategorys(key){
            for (const iterator of this.getEumnList) {
                if(iterator.id == key){
                    return iterator.categoryName
                }
            }
        },
        getCmsAdsLists() {
            // 链接类型
            get('/mpp/utils/getEnum', {
            enumType: 'ads_link_type',
            }).then((res) => {
                if (res.success) {
                    // console.log(res.enumList)
                    this.adsLinkList = res.enumList
                }
            })
            // 是否显示
            get('/mpp/utils/getEnum', {
            enumType: 'yes_no',
            }).then((res) => {
                if (res.success) {
                    // console.log(res.enumList)
                    this.yesNoList = res.enumList
                }
            })
        },
        // 链接类型
        getadslinks(key){
            for (const iterator of this.adsLinkList) {
                if(iterator.key == key){
                    return iterator.value
                }
            }
        },
        // 是否显示
        adsyesno(key){
            for (const iterator of this.yesNoList) {
                if(iterator.key == key){
                    return iterator.value
                }
            }
        },
        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },
        handleNodeClick(data) {
            let id = ''
            if(data){
                id = data.id
                this.ccId = data.id
            }else{
                id = this.ccId
            }
            get(`/cms/ads/findAll`,{categoryId:id}).then((res)=>{
                if(res.success){
                    console.log(res)
                    this.cmsAdsList = res.list
                }
            })
            // this.queryForm.folderId = data.id == '0' ? null : data.id;
        },
        deleteCmsAds(cmsAdsId) {
            let ids = '';
            if (cmsAdsId) {
                ids = cmsAdsId;
            } else {
                ids = this.multipleSelection.map((cmsAds) => cmsAds.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/cms/ads/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleNodeClick();
                            this.closeDialog();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        editCmsAds(cmsAdsId) {
            console.log('cmsAds', cmsAdsId);
            if (cmsAdsId) {
                this.currentCmsAdsId = cmsAdsId;
                this.getCmsAdsById();
            }
            this.showDialog = true;
        },
        getCmsAdsById() {
            get(`/cms/ads/get`,{ id: this.currentCmsAdsId }).then((res) =>{
                if(res.success){
                    this.cmsAds = { ...this.cmsAds, ...res.cmsAds };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        closeDialog() {
            this.showDialog = false
            this.cmsAds = {
                adsName: '', //广告名称
                adsPic: '', //广告图片
                linkType: '', //链接类型
                adsLink: '', //广告链接
                categoryId: '', //分类ID
                isShow: '', //是否显示
                sort: '', //排序
                createTime: '', //
            };
        },
        submitForm(){
            this.$refs.cmsAdsForm.validate((valid) => {
                if (valid) {
                    console.log('submit');
                    post(`/cms/ads/edit`,{ ...this.cmsAds }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleNodeClick();
                            this.closeDialog();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.page{
    display: flex;
    flex-direction: row;
}
.page-content1{
    display: flex;
    width: 100%;
    flex-direction: row;
}
.right{
    flex: 1;
    width: calc(100% - 240px);
    display: flex;
    flex-direction: column;
    .top{
        // flex: 1;
        height: 320px;
        margin-bottom: 8px;
        background-color: #fff;
    }
    .button{
        // flex: 1;
        width: 100%;
        height: 55%;
        background-color: #fff;
    }
}
.left {
    height: 100%;
    width: 240px;
    margin-right: 15px;
    padding: 10px;
    background-color: #fff;
    .add{
      width: 100%;
      height: 40px;
      display: flex;
      color: #606266;
      align-items: center;
    }

    &>div {
      display: flex;
      align-items: center;
      padding: 0 5px;
      cursor: pointer;
    }

    .operation-label {
      margin-left: 3px;
    }

    .search {
      margin: 10px 0;
    }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>